import { render } from "./PlaceOverview.vue?vue&type=template&id=5c3d2c7d"
import script from "./PlaceOverview.vue?vue&type=script&lang=js"
export * from "./PlaceOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__